import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gfFilterRangeFrom'
})
export class GfFilterRangeFrom implements PipeTransform {
    transform(rangeValue: string): string {
        var arrValues = rangeValue.split('|-|');
        return (arrValues.length > 1 && arrValues[0] != '') ? arrValues[0] : '';
    }
};